import React from 'react';
import { Text } from 'rebass';
import styled from 'styled-components';

const StyledText = styled(Text)`
  text-transform: capitalize;
  max-width: 400px;
`;

const Label: React.FC<any> = (props): JSX.Element => (
  <StyledText as="label" fontSize="18px" fontWeight={6} mb={1} {...props} />
);

export default Label;
